// extracted by css-extract-rspack-plugin
export default {"Heading":"no-data-card-module__Heading__JzxFf","Box":"no-data-card-module__Box___5cKd"};